<template>
  <b-button v-if="session && session.provider == 'amazon'" type="is-light" id="change-payment-amzn">{{$t('payment.amazon-pay.change-paymenttype-on-amazon')}}</b-button>
</template>



<script>
import {mapGetters} from 'vuex'
export default {
  name: 'AmazonChangePaymentButton',
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      session: '$_checkout/session',
    }),
  },
  methods: {
    prepare() {
      if ('amazon' in window) {
        this.init()
      } else {
        let amaPayButtons = document.createElement('script')
        amaPayButtons.setAttribute('src', `${process.env.VUE_APP_AMZN_WIDGET}`)
        document.head.appendChild(amaPayButtons)
        this.init()
      }
    },
    init() {
      var pollId = setInterval(poll, 250)
      const tryInit = () => this.initButton()
      function poll() {
        if (!window.amazon) return
        clearTimeout(pollId)
        tryInit()
      }
    },
    async initButton() {
      try {
        window.amazon.Pay.bindChangeAction('#change-payment-amzn', {
          amazonCheckoutSessionId: this.session.session,
          changeAction: 'changePayment',
        })
      } catch (e) {
        this.isAvaialable = false
      }
    },
  },
  async mounted() {
    this.prepare()
  },
}
</script>
